import { Link, createFileRoute, notFound } from "@tanstack/react-router"
import { ChevronLeft } from "lucide-react"

import { getPublicContentFn } from "@/lib/app.functions"

export const Route = createFileRoute("/about/$slug")({
  loader: async ({ params }) => {
    const items = await getPublicContentFn({
      data: { kind: "page", slug: params.slug },
    })
    if (!items[0]) {
      throw notFound()
    }
    return items[0]
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData
          ? `${loaderData.title} · Harbor & Pine Realty`
          : "Information · Harbor & Pine Realty",
      },
    ],
  }),
  component: InformationPage,
})

function InformationPage() {
  const item = Route.useLoaderData()
  return (
    <article className="field-container py-14">
      <Link
        to="/about"
        className="inline-flex items-center gap-2 text-sm font-semibold hover:text-primary"
      >
        <ChevronLeft className="size-4" />
        About this demo
      </Link>
      <div className="mt-8 grid gap-10 border-t-2 border-foreground pt-8 lg:grid-cols-[0.7fr_1.3fr]">
        <div>
          <p className="field-label">Information sheet · {item.slug}</p>
          <h1 className="field-heading mt-3">{item.title}</h1>
          <p className="mt-5 text-base leading-7 text-muted-foreground">
            {item.excerpt}
          </p>
        </div>
        <div className="field-rule min-h-96 border border-border bg-white p-7">
          <p className="max-w-3xl text-base leading-8 whitespace-pre-line">
            {item.body}
          </p>
        </div>
      </div>
    </article>
  )
}
